import React from "react";
import LayOut from "../../components/LayOut";

const UpdateClient = () => {
  return (
    <LayOut>
      <div>UpdateClient</div>
    </LayOut>
  );
};

export default UpdateClient;
